export default [
  {
    path: '/addpayment',
    name: 'addpayment',
    component: () => import('@/views/PaymentManagement/Components/AddPayment.vue'),
    meta: {
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'Add Payment',
      breadcrumb: [
        {
          text: 'Add Payment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payments',
    name: 'allpayments',
    component: () => import('@/views/PaymentManagement/index.vue'),
    meta: {
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'All Payments',
      breadcrumb: [
        {
          text: 'All Payments',
          active: true,
        },
      ],
    },
  },

  {
    path: '/invoice/:id',
    name: 'Payment Invoice',
    component: () => import('@/views/PaymentManagement/Components/invoice.vue'),
    meta: {
      layout: 'full',
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'Payment Invoice',
      breadcrumb: [
        {
          text: 'Payment Invoice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/paymentsdaterange',
    name: 'paymentsdaterange',
    component: () => import('@/views/PaymentManagement/Components/paymentdaterange.vue'),
    meta: {
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'Payment Date Range',
      breadcrumb: [
        {
          text: 'Payment Date Range',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payment-due-list',
    name: 'paymentduelist',
    // Load the due-list page from the Payment Management components directory.
    component: () => import('@/views/PaymentManagement/Components/PaymentDueList.vue'),
    meta: {
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'Payment Due List',
      breadcrumb: [
        {
          text: 'Payment Due List',
          active: true,
        },
      ],
    },
  },

]
